/**
 * Click buttons to show / hide an excerpt or full text
 *
 * HTML
 * A container element with the class js_readMore
 * As child elements:
 * The excerpt element with the class js_readMore__excerpt
 * The full text element with the class js_readMore__fullText
 * A button to show the full text with the class js_readMore__button--showMore
 * A button to show the excerpt with the class js_readMore__button--showLess
 *
 * Parameters
 *
 * buttonHiddenClass (string): a class name (without a leading dot) to hide
 * either of the button elements
 *
 * textHiddenClass (string): a class name (without a leading dot) to hide
 * either of the excerpt or the full text elements
 *
 */

function showLess(lessButton, moreButton, excerpt, fullText, buttonHiddenClass, textHiddenClass) {
    lessButton.classList.add(buttonHiddenClass);
    moreButton.classList.remove(buttonHiddenClass);
    excerpt.classList.remove(textHiddenClass);
    fullText.classList.add(textHiddenClass);
}

function showMore(lessButton, moreButton, excerpt, fullText, buttonHiddenClass, textHiddenClass) {
    lessButton.classList.remove(buttonHiddenClass);
    moreButton.classList.add(buttonHiddenClass);
    excerpt.classList.add(textHiddenClass);
    fullText.classList.remove(textHiddenClass);
}

function init(buttonHiddenClass, textHiddenClass) {
    $(document).ready(() => {
        const container = document.querySelector('.js_readMore');
        let excerpt, fullText, lessButton, moreButton;

        if (container) {
            excerpt = container.querySelector('.js_readMore__excerpt');
            fullText = container.querySelector('.js_readMore__fullText');
            lessButton = container.querySelector('.js_readMore__button--showLess');
            moreButton = container.querySelector('.js_readMore__button--showMore');
        }

        if (excerpt && fullText && lessButton && moreButton) {
            lessButton.addEventListener('click', e => showLess(lessButton, moreButton, excerpt, fullText, buttonHiddenClass, textHiddenClass));
            moreButton.addEventListener('click', e => showMore(lessButton, moreButton, excerpt, fullText, buttonHiddenClass, textHiddenClass));
        }
    });
}

module.exports = init;
